interface TimeInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: string;
  helperText?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export function TimeInput({
  label,
  value,
  onChange,
  required = false,
  error,
  helperText,
  onKeyDown,
}: TimeInputProps) {
  const formatToEDI = (timeStr: string) => {
    if (!timeStr) return '';
    return timeStr.replace(':', '');
  };

  const formatFromEDI = (ediTime: string) => {
    if (!ediTime || ediTime.length !== 4) return '';
    const hours = ediTime.substring(0, 2);
    const minutes = ediTime.substring(2, 4);
    return `${hours}:${minutes}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatToEDI(e.target.value);
    onChange(formatted);
  };

  return (
    <div className="flex flex-col">
      <label className="label-compact block">
        {label}
        {required && <span className="text-red-600 ml-1">*</span>}
      </label>
      <input
        type="time"
        value={formatFromEDI(value)}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        className={`input-compact w-full border rounded-md transition-colors ${
          error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'
        }`}
      />
      {error && <p className="text-xs text-red-600 mt-1">{error}</p>}
      {helperText && !error && (
        <p className="text-xs text-gray-500 mt-1">{helperText}</p>
      )}
    </div>
  );
}
